import type { GoToQuoteNotice } from '../quotes/GenerateMenu';
import { PacklistEditor } from './PacklistEditor';
import './packlists.css';

/**
 * Tab "Sprzętówka" of the event card: the packlist editor itself (owner 2026-10-21 23:31: "normalna zakładka, w której
 * będą pozycje; całe okno mogę otworzyć tak jak kosztorys" — "Pełny widok" of the card). `onGoToQuote`: "Przejdź do
 * kosztorysu" opens the card's tab "Kosztorys" with what was done.
 */
export function PacklistTab({ eventId, onGoToQuote }: { eventId: string; onGoToQuote?: ((notice: GoToQuoteNotice) => void) | undefined }) {
  return (
    <div role="tabpanel" aria-label="Sprzętówka" className="pl-tab">
      <PacklistEditor eventId={eventId} onGoToQuote={onGoToQuote} />
    </div>
  );
}
